import React from "react";
import Select from "react-select";

export default function MultiSelect(props) {
    return (
        <div className={"form-group col-md-" + (props.colNumber || 4)}>
            <label className="text-black font-w600">
                {props.required ? "*" : ""}
                {props.label}
            </label>
            <Select
                options={props.options}
                name={props.name}
                value={
                    props.options
                        ? props.options.find((option) => option.value === props.selectedOption.value)
                        : ""
                }
                onChange={(options) => options ? props.setSelectedOptions(options.map(o => o.value)) : props.setSelectedOptions([])}
                style={{
                    minHeight: "45px",
                    lineHeight: "50px",
                    color: "#7e7e7e",
                    paddingLeft: " 15px",
                }}
                isMulti
            />
        </div>
    );
}
